import { render, staticRenderFns } from "./DownloadAppBtn.vue?vue&type=template&id=3e418f60&scoped=true"
import script from "./DownloadAppBtn.vue?vue&type=script&lang=js"
export * from "./DownloadAppBtn.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppBtn.vue?vue&type=style&index=0&id=3e418f60&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e418f60",
  null
  
)

export default component.exports